<template>
  <div>
    <waterfall :col="col" :width="width" :gutterWidth="grap" :data="data" @finish="finished" ref="waterfall" :isTransition="false">
      <template>
        <div class="imgItems" :style="{width: `${width}px`}" v-for="(item, index) in data" :key="index" :data-grid-groupkey="item.groupKey" @click="showDetail(item)">
          <div class="img-container">
            <div class="imgTop" v-if="item.isTop == 1"></div>
            <hotConcept  v-if="item.isTop == 1" :data="item.hotConcept" :type="'mobile'"></hotConcept>
            <div class="img">
              <img :src="item.thumbnailUrl" alt="" srcset="" />
              <!-- <img src="~@/assets/images/demo/test.jpg" alt="" srcset="" /> -->
            </div>
          </div>
          <div class="title" v-html="find(item.title, search)" :style="{color: titleColor(item.id)}"></div>
          <div class="time"> {{ item.imgDate }}</div>
        </div>
      </template>
    </waterfall>
    <div class="loading" v-if="loading">
      <hxm-loading :bloom="true" color="#232323">{{ $t('26b5bd4947') }}</hxm-loading>
    </div>
  </div>
</template>
<script>
import {mapState} from 'vuex'
import {throttle, uniqueArr} from '@/common'
import hotConcept from '@/components/hotConcept'
export default {
  data() {
    return {
      id: '',
      width: 240,
      grap: 5,
      col: 2,
      loadDistance: 150,
      clicked: [],
      finish: false,
      loading: false,
      handleScroll: () => {}
    }
  },
  components: {
    hotConcept
  },
  props: {
    data: {
      type: Array,
      default: []
    },
    search: {
      type: String,
      default: ''
    },
    type: {
      type: Number,
      default: 1
    },
    isHistory: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    data(newValue, oldValue) {
      if (oldValue.length !== 0) {
        this.finish = false
        this.loading = true
      }
      // let ids = newValue.map(d => d.id);
      // this.$store.commit('setIds', ids);
    }
  },

  inject: ['group'],
  computed: {
    ...mapState(['clickIds'])
  },
  methods: {
    finished() {
      this.loading = false
      this.finish = true
    },
    titleColor(id) {
      let color = this.clickIds.indexOf(id) > -1 ? '#BDBDBD' : '#000000'
      return color
    },
    showDetail(item) {
      let id = item.id
      if (this.isHistory) {
        this.$Talog({
          id: `${window.platformPre}_tushuoshuju.sousuo.jieguodianji`,
          keyword: item.title
        })
      } else {
        this.$Talog({
          id: `${window.platformPre}_tushuoshuju.liebiaodianji`,
          keyword: item.title
        })
      }
      if (navigator.onLine) {
        if (this.finish) {
          let param = `/#/detail?id=${id}&type=${this.type}&content=${this.search}&group=${this.group()}&slideId=${id}`
          window.location.href = "client://client.html?action=ymtz^webid=2804^mode=new^url="+ location.origin + location.pathname + param
          // this.$router.push(`/detail?id=${id}&type=${this.type}&content=${this.search}&group=${this.group()}&slideId=${id}`)
        }
      } else {
        // this.$router.push(`/noNet`)
        window.location.href = "client://client.html?action=ymtz^webid=2804^mode=new^url="+ location.origin + location.pathname +"/#/noNet"
      }
    },
    // loadMore() {
    //   if (this.type === 1) {
    //     this.$Bus.$emit('m-loadMore');
    //   } else {
    //     this.$Bus.$emit('collect-loadMore');
    //   }
    // },
    scroll(e) {
      // const { scrollTop, clientHeight, scrollHeight } = e;
      // let dom = document.querySelector('#vueWaterfall');
      // console.log(scrollHeight, scrollTop, dom.clientHeight, new Date());
      // if (dom) {
      //   if (scrollHeight + scrollTop - dom.clientHeight < 300) {
      //     this.loadMore();
      //   }
      // }
    },
    downImg() {
      this.$parent.downImg()
    },
    collectChange() {
      this.$parent.doCollect()
    },
    find(text, searchVal) {
      if (searchVal === '') return text
      if (!text) return text
      let sText = text
      // 匹配传入的搜索值不区分大小写 i表示不区分大小写，g表示全局搜索
      const searchReg = new RegExp(searchVal, 'gi')
      // 匹配html元素
      const htmlReg = new RegExp('<.*?>', 'ig')
      // 存放html元素的数组
      const aHtml = sText.match(htmlReg)
      // 存放匹配的元素
      const aSearch = sText.match(searchReg)
      // 替换html标签
      sText = sText.replace(htmlReg, '{~}')
      // 替换key
      let a = -1
      sText = sText.replace(searchReg, () => `<span style="color:#e93030">${aSearch[++a]}</span>`)
      let num = -1
      // 恢复html标签
      sText = sText.replace(/{~}/g, () => aHtml[++num])
      return sText
    }
  },
  created() {
    this.handleScroll = throttle(this.scroll, 1000)
  },
  mounted() {
    this.width = Math.floor((window.innerWidth - 15) / 2)
  }
}
</script>
<style lang="less" scoped>
.imgContainer {
  margin: 0px 5px;
}
.imgItems {
  width: 180px;
  .img-container {
    max-height: 240px;
    overflow: hidden;
    border-radius: 6px;
    position: relative;
    .imgTop {
      position: absolute;
      top: 0;
      left: 0;
      width: 36px;
      height: 36px;
      background: url(~@/assets/images/top.svg) 100% 100%;
      background-size: 100% 100%;
    }
    &:hover .introduce {
      display: -webkit-box;
    }
    .img {
      width: 100%;
      pointer-events: none;
      img {
      }
    }
    .introduce {
      font-family: PingFangSC-Medium;
      font-size: 14px;
      color: #ffffff;
      letter-spacing: 0;
      line-height: 22px;
      font-weight: 400;
      position: absolute;
      left: 15px;
      bottom: 15px;
      width: calc(100% - 30px);
      display: -webkit-box;
      -webkit-line-clamp: 2;
      overflow: hidden;
      -webkit-box-orient: vertical;
      display: none;
    }
  }
  .title {
    font-family: PingFangSC-SemiBold;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.84);
    letter-spacing: 0;
    line-height: 20px;
    margin: 4px 5px 0 5px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    overflow: hidden;
    -webkit-box-orient: vertical;
    .match {
      color: #e93030;
    }
  }
  .time {
    font-family: PingFangSC-Regular;
    font-size: 12px;
    color: #999999;
    letter-spacing: 0;
    line-height: 12px;
    font-weight: 400;
    padding: 0 4px;
    margin: 0px 0 12px 0
  }
}
.loading {
  margin: 12px 0;
  display: flex;
  justify-content: center;
}
</style>
